/* eslint-disable */
import Vue from "vue";
import { mapGetters } from "vuex";
// import { getCookie, setCookie } from '@/utils/util.js';

const mixin = {
  data() {
    return {
      $_loading: false,
      $_loadingObj: null,
    };
  },
  methods: {
    $_hideLoading() {
      if (this.$_loading) {
        this.$_loadingObj.close();
        this.$_loading = false;
      }
    },
    $_showLoading(options = {}) {
      if (!this.$_loading) {
        this.$_loadingObj = this.$loading({
          lock: true,
          text: options.text || "Loading",
          target: options.target || "document.body",
          spinner: "el-icon-loading",
          fullscreen: options.target ? false : true,
          background: options.background || "rgba(0, 0, 0, 0.3)",
        });
        this.$_loading = true;
      }
    },
    $_goToLogin(type) {
      // 高新区登录默认跳转个人门户首页
     
      let link =window.ENV_API.YT_URL+"route";
      let routePath = link.replace(/#/g, "%23");
      let url =
        window.ENV_API.PORTAL_API_HOST + "/login?routePath=" + routePath + "&type=1";

      window.location.href = url;
    },
    /**
     * type
     * 0: 当前窗口  1： 新窗口
     */
    $_goToOutGateway(type = 0) {
      const token = window.sessionStorage.getItem("SSOP_TOKEN");
      let url;
      if (token) {
        url = window.ENV_API.OUTSIDE_PORTAL_URL + "?token=" + token;
      } else {
        url = window.ENV_API.OUTSIDE_PORTAL_URL;
      }
      if (type === 0) {
        window.location.href = url;
      } else if (type === 1) {
        window.open(url);
      }

      // 应测试要求，退出等外门户提测之后再跳外门户，先跳登录
      // this.$_goToLogin();
    },
    $_goToLogout() {
      let sToken = window.sessionStorage.getItem("SSOP_TOKEN");
      /**
       * 有 token 就调登出接口，并清缓存
       * 无 token 就掉登录接口登录
       */
      if (sToken) {
        let url = `${
          window.ENV_API.PORTAL_API_HOST
        }/logout?token=${sToken}&routePath=${window.location.href.replace(
          "#",
          encodeURIComponent("#")
        )}`;
        console.log(url);

        let cookieArr = document.cookie.match(/[^ =;]+(?=\=)/g); // eslint-disable-line
        cookieArr &&
          cookieArr.length &&
          cookieArr.map((el) => {
            if (el == "td_cookie") {
              document.cookie =
                el + "=0;expires=" + new Date(0).toUTCString() + "; path=/";
            }
            document.cookie =
              el + "=0;expires=" + new Date(0).toUTCString() + "; path=/";
          });
        sessionStorage.removeItem("SSOP_TOKEN");
        sessionStorage.clear();
        window.location.href = url;
      } else {
        this.$_goToLogin();
      }
    },
  },
};
Vue.mixin(mixin);

/*
 * 定义非全局需要公用插入组件的方法，
 * */
const themeMixin = {
  computed: {
    ...mapGetters(["theme"]),
  },
  watch: {
    theme() {
      // 针对于主题切换，需要改变色彩的第三放插件处理，如地图等。
    },

  },
};

export { themeMixin, mixin };
